
import { EntityId, EntityState } from "@reduxjs/toolkit";
import React from "react";
import { useNavigate } from "react-router-dom";
import ShopListPresentation from "../presentation/ShopListPresentation/ShopListPresentation";
import { ShopType } from "../types/type";
type ShopListProps = {
  shopList: EntityState<ShopType> | null;
  onSort: (fieldName: string) => void;
  sort: string;
  page?:number;
  limit?:number;
  onPage?:(pageNumber:number) => void;
  onLimit?:(limitNumber:number) => void;
  shopCount:number;
};
const ShopListContainer: React.FC<ShopListProps> = ({ shopList, onSort, sort,page,onPage,limit,onLimit , shopCount}) => {
  const navigation = useNavigate();
  const onEditReview = (id: EntityId) => {
    navigation(`/shop/${id}`)
  }

  return (
    <ShopListPresentation
      shopList={shopList!}
      onEditReview={onEditReview}
      onSort={onSort}
      sort={sort}
      page={page}
      limit={limit}
      onLimit={onLimit}
      onPage={onPage}
      shopCount={shopCount}
    />
  )
}

export default ShopListContainer
